module.exports = __webpack_public_path__ + "img/right-leg_hover.72251d48.png";